<template>
  <a href="#" @click.prevent="handleClick">
    {{ $t("domainActivation.protectDomain.desc.line2.2") }}
  </a>
</template>

<script>
import DomainEditModal from "@/components/DomainActivation/DomainEditModal/DomainEditModal.vue";
import { COMMON_MODAL_EMITTERS } from "@/helpers/const";
import bundleEvents from "@/telemetry/bundleEvents";
import { calculateDateDifference, isMobile } from "@/helpers";
import { MEDUSA_EVENTS_MAP } from "@/telemetry/events";
import eventBus from "@/helpers/event-bus";
import { mapGetters } from "vuex";

import { getBundleExpiresOn } from "@/helpers/bundle-billing.helper";
export default {
  name: "ChangeDomainLink",
  props: {
    sourceHook: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentPlanDetails: "currentPlanDetails",
      domain: "domain/domainName",
    }),
  },
  methods: {
    handleClick(e) {
      e.stopPropagation();

      const { autoRenew, isTrial, noOfAccounts } = this.currentPlanDetails;
      // null with order level billing, no bundle expiry to count the trial days from
      const expiresOn = getBundleExpiresOn(this.currentPlanDetails);

      let payload = {
        auto_renew_enabled: autoRenew,
        eventName: MEDUSA_EVENTS_MAP.CHANGE_DOMAIN_CLICKED,
        mailbox_count: noOfAccounts?.active,
        source_hook: this.sourceHook,
      };

      if (isTrial && expiresOn) {
        const freeTrialDaysRemaining = calculateDateDifference(expiresOn);
        payload = {
          ...payload,
          free_trial_days_left: freeTrialDaysRemaining,
        };
      }

      bundleEvents.logChangeDomainClicked({
        ...payload,
        action: "Change domain",
      });

      eventBus.$emit(COMMON_MODAL_EMITTERS.OPEN_MODAL, {
        component: DomainEditModal,
        props: {
          sourceHook: this.sourceHook,
        },
        fullScreenModal: isMobile(),
      });

      this.$emit("clicked");
    },
  },
};
</script>
